import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
    settheTicketsystemrecordgetListDataActions,
    setTheoptions,
    setThecountBasedRenders,
    setTheTrackingDeleteActions,
    setTheTrackingEditionsActions,
    setTheTicketingsystemtRange1,

    setTheTicketingsystemRange2,
    settheTicketingDashboardActions,
    settheTicketIDSActions, setthePriorityStatus,
    setClientBranchActions,
    setZoneActions,
    setRegionActions,
    setGeoLoactionStateAction,
    SetTheDashboardClientList,
    setClientBranchSearchAction,
    setTheticketetailsExportActions,
    settheTicketingSUbOptionValuesListed,

    setTheTicketSystemStateObject,
    setTheTicketSystemRegionObject,
    setTheTicketSystemZoneObject,
    setTheTicketSystemPriorityObject,
    setTheTicketSystemStatusObject,
    setTheTicketSystemBranchObject,
    setTheTicketingsystemtdashboardRange1,
    setTheTicketingsystemDashboardRange2,
    SetActiveTabs,
    setDashboardactiveTabs,
    settheNeardueActions,
    getSideBarfilesActions,
    settheDefualtDatefilyer,
    settheticketsummaryticketstatus,
    settheTicketraiseroutes,
    gettheNearDueClientFilterStates,
    gettheticketdhashboardofROutesActions,
    getthedhashboardtickeyTypeactions,
    setthefindthReassings,
    setTheTicketingsystemStatusState
} from "../../../../Redux/Slice";
import { NavLink, useNavigate } from "react-router-dom";
import ReactTable from "../../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { parseISO, addDays, differenceInDays } from "date-fns";
import { DateRangePicker } from "rsuite";
import { subDays, startOfYear, format } from "date-fns";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
// import { Chart } from "react-google-charts";
import Swal from "sweetalert2";
import _ from "lodash";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeclineIcon from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-31.svg";
import PendignIcons from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-32.svg";
import EmployeeIcons from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-33.svg";

import high from "../../../../Assets/AppComponent/Group 427319195.svg";
import low from "../../../../Assets/AppComponent/Group 427319196.svg";
import medimum from "../../../../Assets/AppComponent/Group 427319197.svg";

import ticketinprogressticker from "../../../../Assets/AppComponent/Group 427320006.svg";
import ticketresolvedticker from "../../../../Assets/AppComponent/Group 427320008.svg";
import ticketreviewsticker from "../../../../Assets/AppComponent/Group 427320007 (1).svg";


import TicketclientBox from "../../../../Assets/AppComponent/Group 427320114.svg";

import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";

import BarChart from './Barchart';
import TickPlacementBars from "./TickPlacementBars";

import TicketIMAGES from "../../../../Assets/AppComponent/Group 427320097.svg";

import CalenderIMg from "../../../../Assets/AppComponent/CalendarBlank.svg";
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from "@mui/material";
import { RechartBeauticompo } from "./Rechartcom";

// import boximg from "../../../../Assets/AppComponent/freepik--Folder--inject-62.svg";

import boximg from "../../../../Assets/AppComponent/Group 427320177.svg";

// import BarChartcom from "./Highchart";
import SimpleBarChart from "./Highchart";
// import BrowserMarketShareChart from "./Highchart";
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";

import Inprogressticket from "../../../../Assets/AppComponent/Union (28).svg";
import reviewticker from "../../../../Assets/AppComponent/Union (31).svg";

import reopenticketslist from "../../../../Assets/AppComponent/Union (33).svg";
import resolvedticket from "../../../../Assets/AppComponent/Union (34).svg";
import Cardimgs from "../../../../Assets/AppComponent/Union (27).svg";
import Arrowtothe_TicketChanges from "../../../../Assets/AppComponent/Vector_Arrow(6).svg";


import overdueimg from "../../../../Assets/AppComponent/Group 427320097.svg";
import OpenTicketimg from "../../../../Assets/AppComponent/Group 427320097 (1).svg";
import InprogressImg from "../../../../Assets/AppComponent/Group 427320098 (1).svg";
import ReviewicketImg from "../../../../Assets/AppComponent/Group 427320099.svg";
import ResolvedTicketImg from "../../../../Assets/AppComponent/Group 427320099 (1).svg";
import LeftArrowsent from "../../../../Assets/LeftArrowImg.svg";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import useDebouncedEffect from 'use-debounced-effect';
import { Customerdatas } from "./Dashboard_folders/Customerdatas";
import { Statebasedtickets } from "./Dashboard_folders/Statebasedtickets";
import CustomedashboardPie from "./Dashboard_folders/CustomedashboardPie";



const TicketDashboard = () => {
    const dispatch = useDispatch();
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );
    const formatDateFilter = (date) => format(date, "yyyy-MM-dd");

    const last30DaysRange = [formatDateFilter(subDays(new Date(), 29)), formatDateFilter(new Date())];
    const lastWeekRange = [formatDateFilter(subDays(new Date(), 6)), formatDateFilter(new Date())];
    const currentYearRange = [formatDateFilter(startOfYear(new Date())), formatDateFilter(new Date())];


    const state = useSelector((state) => state);
    useEffect(() => {
        if (DateFilters == "ThisWeek") {
            dispatch(setTheTicketingsystemtRange1(lastWeekRange[0]));
            dispatch(setTheTicketingsystemRange2(lastWeekRange[1]));
        }
        else if (DateFilters == "ThisMonth") {
            dispatch(setTheTicketingsystemtRange1(last30DaysRange[0]));
            dispatch(setTheTicketingsystemRange2(last30DaysRange[1]));
        }
        else {
            dispatch(setTheTicketingsystemtRange1(currentYearRange[0]));
            dispatch(setTheTicketingsystemRange2(currentYearRange[1]));
        }
    }, [])

    // var UserTypeUds = localStorage.getItem("userTypes");
    // var UserTypeUdsDepartment = localStorage.getItem("userdepartmentTypes");


    // var UserTypeUds = localStorage.getItem("userTypes") == "null"
    //     ? localStorage.getItem("userdepartmentTypes")
    //     : localStorage.getItem("userTypes");
    // var UserTypeUds = state.SideBarFiles.LoginUserdataofassinged?.value  =="external" ? localStorage.getItem("userTypes") == "null"
    // ? localStorage.getItem("userdepartmentTypes")
    // : localStorage.getItem("userTypes") :
    // state.SideBarFiles.LoginUserdataofassinged?.value  == "internal" && 
    // localStorage.getItem("userdepartmentTypes")

    var UserTypeUds = localStorage.getItem("userTypes") == "null"
        ? localStorage.getItem("userdepartmentTypes")
        : localStorage.getItem("userTypes");



    // console.log(UserTypeUds, "apisudaisdi UserTypeUds");



    // let UserTypeUds = localStorage.getItem("userTypes") == null ?  localStorage.getItem("userdepartmentTypes") : localStorage.getItem("userTypes");



    const [showTooltip, setShowTooltip] = useState(false);


    const [multiselect1, setMuliselect1] = useState([state.ClientBranchIDs.TicketSystem_Region,]);
    const [multiselect3, setMuliselect3] = useState([state.ClientBranchIDs.TicketSystem_Zone,]);
    const [nameList5, setOptions5] = useState([]);
    const [Zone, setZone] = useState([]);

    const [datas, setData] = useState({
        zone: state.ClientBranchIDs.TicketSystem_Zone.value,
        state: state.ClientBranchIDs.TicketSystem_State.value,
        region: state.ClientBranchIDs.TicketSystem_Region.value,
    });
    const [multiselect, setMuliselect] = useState([state.ClientBranchIDs.TicketSystem_State,]);
    ///--filter----------------
    let [nameList, setOptions] = useState([]);
    const [nameList2, setOptions2] = useState([]);
    const [REgion, setRegion] = useState([]);
    let Ids = [];
    const [Client, setClients] = useState(state.ClientBranchIDs.TicketSystem_Branch?.value || "");
    const [nameList4, setOptions4] = useState([]);
    const [search, setSearch] = useState("");
    const [selectedValues, SetSelectValue] = useState([]);
    let Priorityoptions = [
        { value: "", label: "All" },
        { value: "0", label: "Low" },
        { value: "1", label: "Medium" },
        { value: "2", label: "High" },
    ]
    const [PriorityValues, setPriorityValues] = useState(state.ClientBranchIDs.TicketSystem_Priority?.value)
    const [prioritySelect, setpriorityselect] = useState(state.ClientBranchIDs.TicketSystem_Priority);
    const [Differentreminders, setremainingTime] = useState(1)
    const Navigate = useNavigate()
    let TicketOptionslited = [
        { value: "external", label: "Assigned" },
        { value: "internal", label: "Sub Assign" },
    ]
    const [TicketoptionListed, setTicketopeionListed] = useState(
        state.SideBarFiles.LoginUserdataofassinged

    )
    // console.log(state.SideBarFiles.LoginUserdataofassinged ,"");


    const optionsStatus = [
        { value: "", label: "All" },
        { value: "0", label: "Open" },
        { value: "1", label: "In Progress" },
        { value: "2", label: "Review" },
        { value: "4", label: "Reopen" },
        { value: "3", label: "Resolved" },

    ];
    const [SttausValues, setStatusValue] = useState(state.ClientBranchIDs.TicketSystem_Status?.value);
    const [Statusopiotns, setStatusoptions] = useState(state.ClientBranchIDs.TicketSystem_Status);
    const [TicketListpoup, setticketlistPopup] = useState(false)

    var remainingTime
    const data = [
        { month: 'January', value: 10 },
        { month: 'February', value: 20 },
        { month: 'March', value: 30 },
        { month: 'April', value: 40 },
    ];

    const [UdsUsers, setUdsusers] = useState(0)
    ///----Filter-----------------------

    const initialStateSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);
    const initialDebouanceSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
        Clientsearch:""
    };
    
    const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);
    

    const [activeButton, setActiveButton] = useState("Open");

    const [downloadpopup, setdownloadpopup] = useState(false)

    const [SubAssignedTicketBool, setSubAssignTicketBool] = useState(false)
    const [DateFilters, setDateFilters] = useState(state.StateManagementOverallCall.DefualtDatefilyer)

    var today = new Date();
    var priorDate = new Date(new Date().setDate(today.getDate() - 30));
    var it = convert(state.StateManagementOverallCall.TicketingsystemDashboardRange1);
    var gt = convert(state.StateManagementOverallCall.TicketingsystemDashboardRange2);
    var startweet = convert(startOfWeek(new Date()));
    var endweek = convert(endOfWeek(new Date()))
    const [range, setrange] = useState(
        state.StateManagementOverallCall.TicketingsystemDashboardRange1 == ""
            ? // [it, gt]
            [startweet, endweek]
            : [it, gt]
    );

    const handlechangedate = (value) => {
        if (value != null) {
            setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
        }
    };
    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            dispatch(setTheTicketingsystemtdashboardRange1(range[0]));
            dispatch(setTheTicketingsystemDashboardRange2(range[1]));
        }
    }, [range]);


    // console.log(state.StateManagementOverallCall.TicketingsystemDashboardRange1, "TicketingsystemDashboardRange1", state.StateManagementOverallCall.TicketingsystemDashboardRange2);

    function convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }

    const formatedDateList = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}`;
    };
    useEffect(() => {
        dispatch(settheTicketraiseroutes(1));
        dispatch(setthefindthReassings(9))
    }, [])

    useEffect(() => {
        if (SubAssignedTicketBool == true) {
            dispatch(getthedhashboardtickeyTypeactions({ value: "internal", label: "Sub Assigned" }))
            setTicketopeionListed({ value: "internal", label: "Sub Assigned" })

        }
        else {
            dispatch(getthedhashboardtickeyTypeactions({ value: "external", label: "Assigned" }))
            setTicketopeionListed({ value: "external", label: "Assigned" })

        }

    }, [SubAssignedTicketBool])



    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {

            const payloads = {
                state: datas.state,
                zone: datas.zone,
                region: datas.region,
                client: Client,
                priority: PriorityValues,
                // status: SttausValues,
                // status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                // activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "over_due" && "over_due",
                // from_date: range[0],
                // to_date: range[1],
                // range: true,
                date: DateFilters,
                chart_type: state.FormsIDList.DashboardNavtabs == 1 ? "ontimeclose" : "reopenrate",
                ticket_type: TicketoptionListed?.value,
            }

            dispatch(settheTicketingDashboardActions(payloads))
        }
    }, [, DateFilters, state.FormsIDList.DashboardNavtabs, datas, Client, PriorityValues, TicketoptionListed?.value])


    useEffect(() => {
        // if (range.length > 0 && !range.includes("NaN-aN-aN")) {
        if (state.ClientBranchIDs.SUBROLE != 3) {
            const payload = {
                search: "",
                page_size: 20,
                page: 1,
                // from_date: range[0],
                // to_date: range[1],
                // range: true,
                // status: selectVal.status,
                // priority: selectVal.priority,
                // state: datas.state,
                region: datas.region,
                zone: datas.zone,
                state: datas.state,
                zone: datas.zone,
                region: datas.region,
                client: Client,
                priority: PriorityValues,
                // status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                //     activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4",
                status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                    activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "over_due" && "over_due",
                // from_date: range[0],
                // to_date: range[1],
                // range: true,
                from_date: range[0],
                to_date: range[1],
                range: true,
                ticket_type: TicketoptionListed?.value,
                ticket_assign: TicketoptionListed?.value == "internal" ? true : ""


                // udsuser: state.SideBarFiles.LoginIDs
            };
            dispatch(settheTicketsystemrecordgetListDataActions(payload));
        }



        else if (TicketListpoup == true && state.ClientBranchIDs.SUBROLE == 3) {

            const payload = {
                search: "",
                page_size: 20,
                page: 1,
                region: datas.region,
                zone: datas.zone,
                state: datas.state,
                zone: datas.zone,
                region: datas.region,
                client: Client,
                from_date: state.StateManagementOverallCall.TicketingsystemRange1,
                to_date: state.StateManagementOverallCall.TicketingsystemRange2,
                range: true,
                priority: PriorityValues,
                status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                    activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "over_due" && "",
                ticket_type: TicketoptionListed?.value,
                ticket_assign: TicketoptionListed?.value == "internal" ? true : "",
                over_due: activeButton == "over_due" ? true : "",

            };
            dispatch(settheTicketsystemrecordgetListDataActions(payload));


        }

        // }, [dtpageindex, dtpagesize, range, selectVal.status, selectVal.priority, search, datas]);
        // }, [])
    }, [datas, Client, PriorityValues, activeButton, TicketListpoup, TicketoptionListed])


    //  settheNeardueActions


    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            const payload = {
                search: "",
                page_size: 20,
                page: 1,
                state: datas.state,
                zone: datas.zone,
                region: datas.region,
                client: Client,
                priority: PriorityValues,
                // status: SttausValues,
                status: activeButton == "All" ? "" : activeButton == "Open" ? "0" : activeButton == "Inprocess" ? "1" :
                    activeButton == "Completed" ? "2" : activeButton == "Close" ? "3" : activeButton == "Reopen" ? "4" : activeButton == "over_due" && "",

                // from_date: range[0],
                // to_date: range[1],
                // range: true,
                ticket_type: TicketoptionListed?.value,
                over_due: activeButton == "over_due" ? true : "",
                date: DateFilters,


                // udsuser: state.SideBarFiles.LoginIDs
            };
            dispatch(settheNeardueActions(payload));
        }
    }, [activeButton, PriorityValues, datas, Client, TicketoptionListed?.value, DateFilters]);
    // }, [])

    // console.log(state.NearDueCallingdatas.Nearduerecords, "Nearduerecords");

    useEffect(() => {
        dispatch(gettheNearDueClientFilterStates({ value: "0", label: "Open" }))

    }, [])
    console.log(state.TrackingrecordgetOfSystemList.TrackingReport, "aospidpoiasd activeButton");

    const handleButtonClick = (button) => {
        // dispatch(settheticketsummaryticketstatus(button))
        setActiveButton(button);
        if (button == "Open") {
            dispatch(gettheNearDueClientFilterStates({ value: "0", label: "Open" }))
        }
        else if (button == "Inprocess") {
            dispatch(gettheNearDueClientFilterStates({ value: "1", label: "In Progress" }))
        }
        else if (button == "Completed") {
            dispatch(gettheNearDueClientFilterStates({ value: "2", label: "Review" }))
        }
        else if (button == "Close") {
            dispatch(gettheNearDueClientFilterStates({ value: "3", label: "Resolved" }))
        }
        else if (button == "Reopen") {
            dispatch(gettheNearDueClientFilterStates({ value: "4", label: "Reopened" }))
        }
        else if (button == "over_due") {
            dispatch(gettheNearDueClientFilterStates({ value: "over_due", label: "Over Due" }))
        }
    };



    ///--------------State-----------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.stateSearch,
            page_size: "",
            page: 1,
        };
        dispatch(setGeoLoactionStateAction(payloads));
    }, [SearchedVal.stateSearch]);

    //--------------_Zone---------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.zoneSearch,
            page_size: 20,
            page: 1,
            counts: 1,
            region_id: datas.region,
        };
        dispatch(setZoneActions(payloads));
        setZone(state.ZonePart.Zone);
    }, [datas.region, SearchedVal.zoneSearch]);

    //-----Region---------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.regionSearch,
            page_size: 20,
            page: 1,
            counts: 1, //-----only we ----get----the----selected regions , the--id only
            state: datas.state,
        };
        dispatch(setRegionActions(payloads));
    }, [datas.state, SearchedVal.regionSearch]);
    const datastate = { state: datas.state, region: datas.region, zone: datas.zone };
    useEffect(() => {
        const payload = {
            search: search,
            page_size: 20,
            page: 1,
            data: datastate,
        };
        dispatch(setClientBranchSearchAction(payload));

    }, [search, datas]);

    const predefinedBottomRanges = [
        {
            label: "Today",
            value: [new Date(), new Date()],
            placement: "left",
        },
        {
            label: "Yesterday",
            value: [addDays(new Date(), -1), addDays(new Date(), -1)],
            placement: "left",
        },
        {
            label: "This week",
            value: [startOfWeek(new Date()), endOfWeek(new Date())],
            placement: "left",
        },
        {
            label: "Last week",
            value: (value, index) => {
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
                ];
            },
            placement: "left",
        },
        {
            label: "Last 30 days",
            value: [subDays(new Date(), 29), new Date()],
            placement: "left",
        },
    ];
    useEffect(() => {
        if (state.GeoState.State != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state.GeoState.State.forEach((element) => {
                objectArray.push({ value: element.id, label: capitalizeEachWord(element.state_name.toLowerCase()) });
            });

            // console.log(objectArray , "objectArray");
            setOptions(objectArray);
        }
    }, [state.GeoState.State, SearchedVal.stateSearch]);


    useEffect(() => {
        if (state.BranchSearchpart.BranchSearch != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state.BranchSearchpart.BranchSearch.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.client_name.toUpperCase(),
                });
            });
            setOptions4(objectArray);
        }
    }, [state.BranchSearchpart.BranchSearch, search]);


    ///  ///----------------------REgion-----------
    useEffect(() => {
        if (state.regioncall.RegionDat != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state.regioncall.RegionDat.forEach((element) => {
                objectArray.push({ value: element.id, label: capitalizeEachWord(element.region_name.toLowerCase()) });

            });

            setOptions2(objectArray);
        }
    }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

    const HandleInputBranch = (e) => {
        setSearchDebounance({
          ...SearchDebounance,
          Clientsearch:e
        
        })  };
            const openMe = () => {
        const rsAnimFade = document.querySelector('.rs-anim-fade');
        const rsAnimPicker = document.querySelector('.rs-picker-popup');

        // .rs-picker-popup
        if (rsAnimFade) {
            rsAnimFade.style.setProperty('left', '1084.89px', 'important');
            rsAnimFade.style.setProperty('top', '125.422px', 'important');

        }
    }

    const CloseDateRange = () => {
        const rsAnimFade = document.querySelector('.rs-anim-fade');
        if (rsAnimFade) {
            rsAnimFade.style.setProperty('display', 'none', 'important');
        }
    }
    const cleaningrange = () => {
        //setrange([gt,it]);
    };

    //----Region----------------
    const handelRegionSlect = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect1(selectedVal);
            setMuliselect3({ value: "", label: "All" });

            setData({
                ...datas,
                region: selectedVal.value,
            });
            dispatch(setTheTicketSystemRegionObject(selectedVal));

            dispatch(setTheTicketSystemZoneObject({ value: "", label: "All" }));

        }
        if (selectedVal == null) {
            setData({
                ...datas,
                region: "",
                zone: "",
            });
            dispatch(setTheTicketSystemRegionObject({ value: "", label: "All" }));

            dispatch(setTheTicketSystemZoneObject({ value: "", label: "All" }));


            setMuliselect3({ value: "", label: "All" });
            setMuliselect1({ value: "", label: "All" });
        }
        setClients("")
                dispatch(setTheTicketSystemBranchObject({ value: "", label: "All" }));

    };
    //----------------Zone
    const handleZone = (selectedVal) => {
        //console.log(selectedVal ,"selected Values");
        if (selectedVal != null) {
            setMuliselect3(selectedVal);
            setData({
                ...datas,
                zone: selectedVal.value,
            });

            dispatch(setTheTicketSystemZoneObject(selectedVal));

        }
        if (selectedVal == null) {
            setData({
                ...datas,
                zone: "",
            });

            dispatch(setTheTicketSystemZoneObject({ value: "", label: "All" }));

            setMuliselect3({ value: "", label: "All" });
        }
                setClients("")
                dispatch(setTheTicketSystemBranchObject({ value: "", label: "All" }));

    };
    const handleSelectChange = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect(selectedVal);
            setMuliselect1({ value: "", label: "All" });
            setMuliselect3({ value: "", label: "All" });

            setData({
                ...datas,
                state: selectedVal.value,
                zone: "",
                region: "",
            });

            setClients("");

            dispatch(setTheTicketSystemStateObject(selectedVal));



        }
        if (selectedVal == null) {
            setMuliselect({ value: "", label: "All" });
            setMuliselect1({ value: "", label: "All" });
            setMuliselect3({ value: "", label: "All" });
            setData({
                ...datas,
                state: "",
                zone: "",
                region: "",
            });
            setClients("");

            dispatch(setTheTicketSystemStateObject({ value: "", label: "All" }));

        }

        dispatch(setTheTicketSystemRegionObject({ value: "", label: "All" }));

        dispatch(setTheTicketSystemZoneObject({ value: "", label: "All" }));
        dispatch(setTheTicketSystemBranchObject({ value: "", label: "All" }));


    };
    ///-------------Zone--------------
    useEffect(() => {
        if (state.ZonePart.Zone != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "All" });
            state.ZonePart.Zone.forEach((element) => {
                objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
            });
            setOptions5(objectArray);
        }
    }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

    const HandleClientBranches = (selectedVal) => {

        if (selectedVal != null) {
            dispatch(setTheTicketSystemBranchObject(selectedVal));

            SetSelectValue(selectedVal);
            setClients(selectedVal.value);
            SetSelectValue(selectedVal);
        }
        else {

            dispatch(setTheTicketSystemBranchObject({ value: '', label: "All" }));

            SetSelectValue([]);
            setClients("");
            SetSelectValue([]);
        }
    };


 
 
    useDebouncedEffect(
        () => {
            if (setSearchDebounance) {
                setSearched({
                    ...SearchedVal,
                    stateSearch: SearchDebounance.stateSearch,
                    regionSearch: SearchDebounance.regionSearch,
                    zoneSearch: SearchDebounance.zoneSearch,
                });
               setSearch(SearchDebounance.Clientsearch)
            }
        },
        500,
        [SearchDebounance]
    );
    
    ///-----State----Input Changes
    const handleInputChange = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            stateSearch: Val,
    
        });
    
    };
    
    ///---Region-----------------
    const handleInputRegion = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            regionSearch: Val,
        });
    };
    ///----Zone---Name
    const handleInputZone = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            zoneSearch: Val,
        });
    };
    
     

    const HandleTheExports = () => {
        // const payloads = {
        //     state: datas.state,
        //     zone: datas.zone,
        //     region: datas.region,
        //     client: Client,
        //     priority: PriorityValues,
        //     status: SttausValues,

        // }
        // dispatch(setTheticketetailsExportActions(payloads))

        const payloads = {
            ticketapis: 1,
            parasnadata: {
                state: datas.state,
                zone: datas.zone,
                region: datas.region,
                client: Client,
                priority: PriorityValues,
                status: SttausValues,
            }

        }
        dispatch(setTheticketetailsExportActions(payloads))

        setdownloadpopup(false);

    }
    console.log(state.SideBarFiles.NearDueStatusFilterClient, "state.SideBarFiles.NearDueStatusFilterClient");

    const MoveTotheNextTab = () => {
        if (TicketoptionListed?.value == "external") {
            dispatch(getSideBarfilesActions("Tickets"));
            if (activeButton == "All") {
                dispatch(setTheTicketingsystemStatusState({ value: "", label: "All" }))

            }
            else if (activeButton == "Open") {
                dispatch(setTheTicketingsystemStatusState({ value: "0", label: "Open" }))
            }
            else if (activeButton == "Inprocess") {
                dispatch(setTheTicketingsystemStatusState({ value: "1", label: "In Progress" }))
            }
            else if (activeButton == "Completed") {
                dispatch(setTheTicketingsystemStatusState({ value: "2", label: "Review" }))
            }
            else if (activeButton == "Close") {
                dispatch(setTheTicketingsystemStatusState({ value: "3", label: "Resolved" }))
            }
            else if (activeButton == "Reopen") {
                dispatch(setTheTicketingsystemStatusState({ value: "4", label: "Reopened" }))
            }
            else if (activeButton == "over_due") {
                dispatch(setTheTicketingsystemStatusState({ value: "over_due", label: "Over Due" }))
            }



            if (DateFilters == "ThisWeek") {
                dispatch(setTheTicketingsystemtRange1(lastWeekRange[0]));
                dispatch(setTheTicketingsystemRange2(lastWeekRange[1]));
            }
            else if (DateFilters == "ThisMonth") {
                dispatch(setTheTicketingsystemtRange1(last30DaysRange[0]));
                dispatch(setTheTicketingsystemRange2(last30DaysRange[1]));
            }
            else {
                dispatch(setTheTicketingsystemtRange1(currentYearRange[0]));
                dispatch(setTheTicketingsystemRange2(currentYearRange[1]));
            }
            Navigate("/ticketlist");

        }
        else {
            // dispatch(settheTicketingSUbOptionValuesListed(state.SideBarFiles.NearDueStatusFilterClient))
            if (activeButton == "All") {
                dispatch(settheTicketingSUbOptionValuesListed({ value: "", label: "All" }))
            }
            if (activeButton == "Open") {
                dispatch(settheTicketingSUbOptionValuesListed({ value: "0", label: "Open" }))
            }
            else if (activeButton == "Inprocess") {
                dispatch(settheTicketingSUbOptionValuesListed({ value: "1", label: "In Progress" }))
            }
            else if (activeButton == "Completed") {
                dispatch(settheTicketingSUbOptionValuesListed({ value: "2", label: "Review" }))
            }
            else if (activeButton == "Close") {
                dispatch(settheTicketingSUbOptionValuesListed({ value: "3", label: "Resolved" }))
            }
            else if (activeButton == "Reopen") {
                dispatch(settheTicketingSUbOptionValuesListed({ value: "4", label: "Reopened" }))
            }
            else if (activeButton == "over_due") {
                dispatch(settheTicketingSUbOptionValuesListed({ value: "over_due", label: "Over Due" }))
            }


            dispatch(getSideBarfilesActions("Sub Assigned"));
            Navigate("/sub_ticker");
        }
        // setSelectedSideBarTab("Tickets")

    }




    const MoveTotheNextNeardue = () => {
        dispatch(getSideBarfilesActions("Dashboard "));
        if (TicketoptionListed?.value == "external") {
            dispatch(getthedhashboardtickeyTypeactions({ value: "external", label: "Assigned" }))

            Navigate("/neardue_client");
        } else {
            dispatch(getthedhashboardtickeyTypeactions({ value: "internal", label: "Sub Assign" }))
            Navigate("/neardue_client");
        }
        // setSelectedSideBarTab("Tickets")

    }

    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);

        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = dateObject.getFullYear();

        return `${day} / ${month} / ${year}`;
    };
    const capitalizeEachWord = (str) => {
        return str
            .split(' ') // Split the string into an array of words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(' '); // Join the words back into a string
    };

    const HandleTheNeardueTickets = (datas) => {
        dispatch(getSideBarfilesActions("Dashboard "));
        if (state.SideBarFiles.LoginUserdataofassinged?.value == "external") {



            setTimeout(() => {
                dispatch(settheTicketIDSActions(datas.id)); /// ticket id
            }, 50);
            setTimeout(() => {
                Navigate("/ticketviews")
            }, 300);
        }
        else {
            dispatch(settheTicketIDSActions(datas.id)); /// ticket id

            dispatch(gettheticketdhashboardofROutesActions(8)) // if it is move from the client dashboard set it as 7 

            Navigate("/sub_ticket_internal_view")
        }
    }


    console.log(state.StateManagementOverallCall.TicketIDS, "TicketIDS Ids");

    function overdueFunctionspercentanges(item) {
        console.log(item, "sadiuasidu item");

        const overdueMinutes = (item / 100);

        return overdueMinutes;

    }


    const overdueFunctions = (ticketretrieve) => {
        const convertToMinutes = (days, hours, minutes) => (days * 24 * 60) + (hours * 60) + minutes;
        let differenceInMinutes
        function calculateTimeStatus(differenceInMinutes) {
            console.log(differenceInMinutes, 'differenceInMinutes');

            if (differenceInMinutes > 0 || differenceInMinutes == 0) {
                return "Overdue";
            }

            if (Math.abs(differenceInMinutes) >= 1440) {
                // More than or equal to 1 day
                const days = Math.floor(Math.abs(differenceInMinutes) / (60 * 24));
                return `${days} Days left`;
            }

            if (Math.abs(differenceInMinutes) >= 60) {
                // More than or equal to 1 hour
                const hours = Math.floor(Math.abs(differenceInMinutes) / 60);
                return `${hours} Hours left`;
            }

            // Less than 1 hour
            const minutes = differenceInMinutes * -1;
            return `Minutes left ${minutes}`;
        }
        var remainingTimevalues


        const formatTime = (ms) => {
            const days = Math.floor(ms / (1000 * 60 * 60 * 24));
            const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
            return { days, hours, minutes };
        };

        const formatTimeLevel = (ms, Levelonbetypes) => {
            return {
                days: Levelonbetypes === "2" ? ms : 0,
                hours: Levelonbetypes === "1" ? ms : 0,
                minutes: Levelonbetypes === "0" ? ms : 0,
            };
        };

        if (ticketretrieve?.created_at && ticketretrieve?.client_id?.l1_user_TAT) {
            const createdDate = new Date(ticketretrieve.created_at);
            const currentDate = new Date();
            const differenceInMs = currentDate - createdDate;

            const timeDifference = formatTime(differenceInMs);

            const LevelonbeTAT = Number(ticketretrieve.client_id.l1_user_TAT);
            const Levelonbetypes = ticketretrieve.client_id.l1_time_type;

            const period1Minutes = convertToMinutes(
                timeDifference.days,
                timeDifference.hours,
                timeDifference.minutes
            );

            const period2Minutes = convertToMinutes(
                Levelonbetypes === "2" ? LevelonbeTAT : 0,
                Levelonbetypes === "1" ? LevelonbeTAT : 0,
                Levelonbetypes === "0" ? LevelonbeTAT : 0
            );

            differenceInMinutes = period1Minutes - period2Minutes;
            remainingTimevalues = calculateTimeStatus(differenceInMinutes);
            console.log(differenceInMinutes, " asdasdasd differenceInMnutes", differenceInMinutes > 0, remainingTimevalues);
            overdueFunctionspercentanges(differenceInMinutes * -1)

            return remainingTimevalues

        }

        return remainingTimevalues


    };


    const overdueFunctionsDepartment = (ticketretrieve) => {
        const convertToMinutes = (days, hours, minutes) => (days * 24 * 60) + (hours * 60) + minutes;
        let differenceInMinutes

        function calculateTimeStatus(differenceInMinutes) {
            console.log(differenceInMinutes, 'differenceInMinutes');

            if (differenceInMinutes > 0 || differenceInMinutes == 0) {
                return "Overdue";
            }

            if (Math.abs(differenceInMinutes) >= 1440) {
                // More than or equal to 1 day
                const days = Math.floor(Math.abs(differenceInMinutes) / (60 * 24));
                return `${days} Days left`;
            }

            if (Math.abs(differenceInMinutes) >= 60) {
                // More than or equal to 1 hour
                const hours = Math.floor(Math.abs(differenceInMinutes) / 60);
                return `${hours} Hours left`;
            }

            // Less than 1 hour
            const minutes = differenceInMinutes * -1;
            return `Minutes left ${minutes}`;
        }
        var remainingTimevalues


        const formatTime = (ms) => {
            const days = Math.floor(ms / (1000 * 60 * 60 * 24));
            const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
            return { days, hours, minutes };
        };

        const formatTimeLevel = (ms, Levelonbetypes) => {
            return {
                days: Levelonbetypes === "2" ? ms : 0,
                hours: Levelonbetypes === "1" ? ms : 0,
                minutes: Levelonbetypes === "0" ? ms : 0,
            };
        };

        if (ticketretrieve?.created_at && ticketretrieve?.department_users?.l1_user_TAT) {
            const createdDate = new Date(ticketretrieve.created_at);
            const currentDate = new Date();
            const differenceInMs = currentDate - createdDate;

            const timeDifference = formatTime(differenceInMs);

            const LevelonbeTAT = Number(ticketretrieve.department_users.l1_user_TAT);
            const Levelonbetypes = ticketretrieve.department_users.l1_time_type;

            const period1Minutes = convertToMinutes(
                timeDifference.days,
                timeDifference.hours,
                timeDifference.minutes
            );

            const period2Minutes = convertToMinutes(
                Levelonbetypes === "2" ? LevelonbeTAT : 0,
                Levelonbetypes === "1" ? LevelonbeTAT : 0,
                Levelonbetypes === "0" ? LevelonbeTAT : 0
            );

            differenceInMinutes = period1Minutes - period2Minutes;
            remainingTimevalues = calculateTimeStatus(differenceInMinutes);
            console.log(differenceInMinutes, " asdasdasd differenceInMnutes", differenceInMinutes > 0, remainingTimevalues);
            // Convert the difference back to days, hours, and minutes
            // Debugging log




            overdueFunctionspercentanges(differenceInMinutes * -1)

            return remainingTimevalues
        }

        return remainingTimevalues


    };


    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };


    return (


        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "4px 10px" }}
                >
                    <div
                        class="col-12 "
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            height: "76px"
                        }}
                    >
                        <h3
                            className="TicketDasboardHeader">Dashboard</h3>

                        <div className="FilterofTicketDashboards" style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "center" }}>
                            {/* <Select
                                className="Selectsfilter"
                                onChange={(e) => {
                                    dispatch(getthedhashboardtickeyTypeactions(e))
                                    setTicketopeionListed(e)
                                }}
                                styles={{ marginTop: "2px" }}
                                options={TicketOptionslited}
                                placeholder={""}
                                value={TicketoptionListed}
                                labelledBy="Select"
                            /> */}

                            <button className={`DateFiltersTicket ${DateFilters == "ThisWeek" ? "Active" : ""}`}
                                onClick={() => {
                                    dispatch(settheDefualtDatefilyer("ThisWeek"))

                                    dispatch(setTheTicketingsystemtRange1(lastWeekRange[0]));
                                    dispatch(setTheTicketingsystemRange2(lastWeekRange[1]));
                    

                                    setDateFilters("ThisWeek");
                                }}
                            >7 Days</button>
                            <button className={`DateFiltersTicket ${DateFilters == "ThisMonth" ? "Active" : ""}`}
                                onClick={() => {
                                    dispatch(settheDefualtDatefilyer("ThisMonth"))
                                    dispatch(setTheTicketingsystemtRange1(last30DaysRange[0]));
                                    dispatch(setTheTicketingsystemRange2(last30DaysRange[1]));
                    
                                    setDateFilters("ThisMonth")
                                }}
                            >Month</button>
                            <button className={`DateFiltersTicket ${DateFilters == "ThisYear" ? "Active" : ""}`}
                                onClick={() => {
                                    dispatch(settheDefualtDatefilyer("ThisYear"))
                                    dispatch(setTheTicketingsystemtRange1(currentYearRange[0]));
                                    dispatch(setTheTicketingsystemRange2(currentYearRange[1]));                    
                                    setDateFilters("ThisYear")
                                }}
                            >Year</button>



                            {state.SideBarFiles.LoginUserdataofassinged?.value == "external" && (

                                <div className="" >
                                    <button
                                        align="center"
                                        type="button"
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            background: "transparent",
                                        }}
                                        className="DownloadBTNS"
                                        onClick={(e) => {
                                            HandleTheExports()
                                            // setdownloadpopup(true)
                                        }}
                                    >
                                        <a class="dnbtn"></a>
                                    </button>

                                </div>
                            )}
                        </div>


                    </div>


                </div>

                <div
                    className="row  Filtersdashboardstatus "

                >
                    <div
                        className="col-sm-2"
                    >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            State
                        </label>
                        <Select
                            className="Selectsfilter"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => {
                                setMuliselect(e);
                            }}
                            onChange={(e) => {
                                handleSelectChange(e);
                            }}
                            options={nameList}
                            onInputChange={handleInputChange}
                            onremoved={(e) => {
                                setMuliselect({ value: "", label: "All" });
                                console.log(e, "jjk9090");
                            }}
                            value={multiselect}
                            labelledBy="Select"
                        />
                    </div>

                    <div
                        className="col-sm-2" >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Region
                        </label>
                        <Select
                            className="Selectsfilter"

                            // className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect1(e)}
                            onChange={(e) => {
                                handelRegionSlect(e);
                            }}
                            options={nameList2}
                            labelledBy="Select"
            isClearable={
  multiselect1
    ? Array.isArray(multiselect1)
      ? multiselect1.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect1.label === "ALL" || multiselect1.label === "All"
      ? false
      : true
    : true
}                            onremoved={(e) => {
                                setMuliselect1(e);
                            }}
                            value={multiselect1}
                            onInputChange={handleInputRegion}
                        />
                    </div>

                    <div
                        className="col-sm-2" >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Zone
                        </label>
                        <Select
                            className="Selectsfilter"

                            // className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect3(e)}
                            onChange={(e) => {
                                handleZone(e);
                            }}
                            value={multiselect3}
                            options={nameList5}
              isClearable={
  multiselect3
    ? Array.isArray(multiselect3)
      ? multiselect3.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect3.label === "ALL" || multiselect3.label === "All"
      ? false
      : true
    : true
}                            onremoved={(e) => {
                                setMuliselect3(e);
                                console.log(e, "jjk9090");
                            }}
                            labelledBy="Select"
                            onInputChange={handleInputZone}
                        />
                    </div>

                    <div
                        className="col-sm-2">
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Client
                        </label>
                        <Select
                            className="Selectsfilter"

                            // className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                                HandleClientBranches(e);
                            }}
                            options={nameList4}
                            labelledBy="Select"
                            onInputChange={HandleInputBranch}
              isClearable={
  state.ClientBranchIDs.TicketSystem_Branch
    ? Array.isArray(state.ClientBranchIDs.TicketSystem_Branch)
      ? state.ClientBranchIDs.TicketSystem_Branch.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : state.ClientBranchIDs.TicketSystem_Branch.label === "ALL" || state.ClientBranchIDs.TicketSystem_Branch.label === "All"
      ? false
      : true
    : true
}                            value={state.ClientBranchIDs.TicketSystem_Branch}
                        />
                    </div>
                    <div
                        className="col-sm-2"

                    >
                        <label
                            class="form-label"

                        >
                            Priority
                        </label>

                        <Select
                            className="Selectsfilter"

                            // className="Selects"
                            styles={{ position: "relative", top: "60px" }}

                            placeholder="search"
                            options={Priorityoptions}
                            onChange={(e) => {
                                setpriorityselect(e)
                                setPriorityValues(e.value)
                                dispatch(setTheTicketSystemPriorityObject(e))
                            }}
                            value={prioritySelect}
                        />
                    </div>

                    <div
                        className="col-sm-2"

                    >
                        <label
                            class="form-label"

                        >
                            Status
                        </label>

                        <Select
                            className="Selectsfilter"

                            // className="Selects"
                            styles={{ position: "relative", top: "60px" }}

                            placeholder="search"
                            options={optionsStatus}
                            onChange={(e) => {
                                setStatusoptions(e)
                                setStatusValue(e.value)
                                dispatch(setTheTicketSystemStatusObject(e))
                            }}
                            value={Statusopiotns}
                        />
                    </div>

                </div>


                {
                    // UserTypeUds != "l2" 
                    state.ClientBranchIDs.SUBROLE == 3 || UserTypeUds == "l3"
                        ?
                        <div className="col-12 DashboardOverviewticketingforadmin">
                            <div
                                className="row TicketingDashboard TicketingDashboardforadmin"
                                style={{ marginBottom: "44px", padding: "0" }}
                            >

                                <div
                                    className="col-sm-2"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                    }}

                                >
                                    <div
                                        className="card Dashboard01"
                                        style={{
                                            borderRadius: "7px",
                                            border: "none",
                                            cursor: state.ClientBranchIDs.SUBROLE == 3 ? "pointer" : "none"
                                        }}
                                        onClick={() => {
                                            if (state.ClientBranchIDs.SUBROLE == 3) {
                                                handleButtonClick("All")
                                                setticketlistPopup(true)
                                            }
                                        }
                                        }
                                    >
                                        <div
                                            className="card-Body TicketDashboardCardBody"

                                        >
                                            <div className="InnerCardofTicket">
                                                <div
                                                    className=" iconsEmpVer">

                                                    <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                </div>

                                                <div
                                                    className="Counts"
                                                    style={{
                                                        fontSize: "30px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        // width: "126px"
                                                    }}
                                                >
                                                    <span
                                                    >
                                                        Total Tickets
                                                    </span>
                                                </div>
                                            </div>


                                            <div className="CountsOftickets">
                                                <span
                                                    className="DashboardCardHeader"
                                                >
                                                    {state.Ticketingrecord_dashboard.ticketDashboardData.total_count ?
                                                        state.Ticketingrecord_dashboard.ticketDashboardData.total_count :
                                                        "0"
                                                    }

                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="col-sm-2"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                    }}

                                >
                                    <div
                                        className="card Dashboard01"
                                        style={{
                                            borderRadius: "7px",
                                            border: "none",
                                            cursor: state.ClientBranchIDs.SUBROLE == 3 ? "pointer" : "none"

                                        }}
                                        onClick={() => {
                                            if (state.ClientBranchIDs.SUBROLE == 3) {
                                                handleButtonClick("Close")
                                                setticketlistPopup(true)
                                            }
                                        }
                                        }
                                    >
                                        <div
                                            className="card-Body TicketDashboardCardBody"

                                        >
                                            <div className="InnerCardofTicket">
                                                <div
                                                    className=" iconsEmpVer">

                                                    <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                </div>

                                                <div
                                                    className="Counts"
                                                    style={{
                                                        fontSize: "30px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        // width: "126px"
                                                    }}
                                                >
                                                    <span
                                                    >
                                                        Resolved Tickets
                                                    </span>
                                                </div>
                                            </div>


                                            <div className="CountsOftickets">
                                                <span
                                                    className="DashboardCardHeader"
                                                >
                                                    {state.Ticketingrecord_dashboard.ticketDashboardData.close_ticketing_count ?
                                                        state.Ticketingrecord_dashboard.ticketDashboardData.close_ticketing_count :
                                                        "0"
                                                    }

                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div className="unresolved-tickets">
                                    <div
                                        className="Collist"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",

                                        }}

                                    >
                                        <div
                                            className="card Dashboard01"
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: state.ClientBranchIDs.SUBROLE == 3 ? "pointer" : "none"

                                            }}
                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"
                                                onClick={() => {
                                                    if (state.ClientBranchIDs.SUBROLE == 3) {
                                                        handleButtonClick("Open")
                                                        setticketlistPopup(true)
                                                    }
                                                }
                                                }
                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Unresolved Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.Ticketingrecord_dashboard.ticketDashboardData.unresolved_tickets ?
                                                            state.Ticketingrecord_dashboard.ticketDashboardData.unresolved_tickets :
                                                            "0"
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="Innerdetails">
                                            <div className={`detail-item ${state.ClientBranchIDs.SUBROLE == 3 ? "adminAccesstabs" : ""}`}
                                                onClick={() => {
                                                    if (state.ClientBranchIDs.SUBROLE == 3) {
                                                        handleButtonClick("Open")
                                                        setticketlistPopup(true)
                                                    }
                                                }
                                                }


                                            >                                                <span className="count">{state.Ticketingrecord_dashboard.ticketDashboardData.open_ticketing_count ?
                                                state.Ticketingrecord_dashboard.ticketDashboardData.open_ticketing_count :
                                                "0"
                                            }</span>
                                                <span className="label open">Open</span>
                                            </div>
                                            <div className={`detail-item ${state.ClientBranchIDs.SUBROLE == 3 ? "adminAccesstabs" : ""}`}
                                                onClick={() => {
                                                    if (state.ClientBranchIDs.SUBROLE == 3) {
                                                        handleButtonClick("Inprocess")
                                                        setticketlistPopup(true)
                                                    }
                                                }
                                                }
                                            >                                                <span className="count">{state.Ticketingrecord_dashboard.ticketDashboardData.inprocess_ticketing_count ?
                                                state.Ticketingrecord_dashboard.ticketDashboardData.inprocess_ticketing_count :
                                                "0"
                                            }</span>
                                                <span className="label in-progress">In Progress</span>
                                            </div>
                                            <div className={`detail-item ${state.ClientBranchIDs.SUBROLE == 3 ? "adminAccesstabs" : ""}`}
                                                onClick={() => {
                                                    if (state.ClientBranchIDs.SUBROLE == 3) {
                                                        handleButtonClick("Completed")
                                                        setticketlistPopup(true)
                                                    }
                                                }
                                                }
                                            >                                                <span className="count">{state.Ticketingrecord_dashboard.ticketDashboardData.review_tickets_count ?
                                                state.Ticketingrecord_dashboard.ticketDashboardData.review_tickets_count :
                                                "0"
                                            }</span>
                                                <span className="label review">Review</span>
                                            </div>
                                            <div className={`detail-item ${state.ClientBranchIDs.SUBROLE == 3 ? "adminAccesstabs" : ""}`}
                                                onClick={() => {
                                                    if (state.ClientBranchIDs.SUBROLE == 3) {
                                                        handleButtonClick("Reopen")
                                                        setticketlistPopup(true)
                                                    }
                                                }
                                                }
                                            ><span className="count">{state.Ticketingrecord_dashboard.ticketDashboardData.reopen_ticketing_count ?
                                                state.Ticketingrecord_dashboard.ticketDashboardData.reopen_ticketing_count :
                                                "0"
                                            }</span>
                                                <span className="label reopen">Reopen</span>
                                            </div>
                                            <div className="detail-item">
                                                {/* <span className="count">05</span> */}
                                                <span className="count">{state.Ticketingrecord_dashboard.ticketDashboardData.over_due_ticket_count ?
                                                    state.Ticketingrecord_dashboard.ticketDashboardData.over_due_ticket_count :
                                                    "0"
                                                }</span>
                                                <span className="label overdue">Overdue</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>




                            </div>
                        </div>

                        :

                        UserTypeUds == "l2" || UserTypeUds == "l1" ?

                            <div className="col-12  ticket-dashboard_Ticketclient">
                                <div className=" Ticketdetails"

                                >
                                    <div className=" Innerticket-dashboard text-center">

                                        <div
                                            className={`col-md-4 CardDesigns mb-3 ${activeButton === "over_due" ? "active-card" : ""
                                                }`}
                                            onClick={() => handleButtonClick("over_due")}
                                        >
                                            <div className="card p-3">
                                                <div className="InnercardImgData InnercardImgDataTicketcreate">
                                                    <span className="clientTicketBgImgs">
                                                        <img src={overdueimg} alt="Card Icon" />
                                                    </span>
                                                    <h2>{state.Ticketingrecord_dashboard.ticketDashboardData.over_due_ticket_count}</h2>
                                                </div>
                                                <h5>Over Due Tickets</h5>
                                            </div>
                                        </div>
                                        <div
                                            className={`col-md-4 CardDesigns mb-3 ${activeButton === "Open" ? "active-card" : ""
                                                }`}
                                            onClick={() => handleButtonClick("Open")}
                                        >
                                            <div className="card p-3">
                                                <div className="InnercardImgData InnercardImgDataTicketcreate">
                                                    <span className="clientTicketBgImgs">
                                                        <img src={OpenTicketimg} alt="Card Icon" />
                                                    </span>
                                                    <h2>{state.Ticketingrecord_dashboard.ticketDashboardData.open_ticketing_count}</h2>
                                                </div>
                                                <h5>Open Tickets</h5>
                                            </div>
                                        </div>

                                        <div
                                            className={`col-md-4 CardDesigns mb-3 ${activeButton === "Inprocess" ? "active-card" : ""
                                                }`}
                                            onClick={() => handleButtonClick("Inprocess")}
                                        >
                                            <div className="card p-3">
                                                <div className="InnercardImgData">
                                                    <span className="clientTicketBgImgs">
                                                        <img src={InprogressImg} alt="Card Icon" />
                                                    </span>
                                                    <h2>{state.Ticketingrecord_dashboard.ticketDashboardData.inprocess_ticketing_count}</h2>
                                                </div>
                                                <h5>In Progress Tickets</h5>
                                            </div>
                                        </div>

                                        <div
                                            className={`col-md-4 mb-3 ${activeButton === "Completed" ? "active-card" : ""
                                                }`}
                                            onClick={() => handleButtonClick("Completed")}
                                        >
                                            <div className="card p-3">
                                                <div className="InnercardImgData">
                                                    <span className="clientTicketBgImgs">
                                                        <img src={ReviewicketImg} alt="Card Icon" />
                                                    </span>
                                                    <h2>{state.Ticketingrecord_dashboard.ticketDashboardData.review_tickets_count}</h2>
                                                </div>
                                                <h5>Review Tickets</h5>
                                            </div>
                                        </div>


                                        <div
                                            className={`col-md-4 mb-3 ${activeButton === "Close" ? "active-card" : ""
                                                }`}
                                            onClick={() => handleButtonClick("Close")}
                                        >
                                            <div className="card p-3">
                                                <div className="InnercardImgData">
                                                    <span className="clientTicketBgImgs">
                                                        <img src={ResolvedTicketImg} alt="Card Icon" />
                                                    </span>
                                                    <h2>{state.Ticketingrecord_dashboard.ticketDashboardData.resolved_tickets}</h2>
                                                </div>
                                                <h5>Resolved Tickets</h5>
                                            </div>
                                        </div>

                                        <div
                                            className={`col-md-4 CardDesigns CardDesignsSubAssign mb-3
                                            3
                                            `}
                                            onClick={(e) => {
                                                setSubAssignTicketBool(!SubAssignedTicketBool)
                                            }}
                                        >
                                            <div className="card ">
                                                <div className="InnercardImgData InnercardImgDataTicketcreate InnercardImgDataTicketcreateClient" >
                                                    <span className="clientTicketBgImgsChanging"
                                                    >
                                                        {SubAssignedTicketBool == false ?
                                                            "SUB ASSIGNED TICKETS"
                                                            : "ASSIGNED TICKETS"}


                                                        <button
                                                            style={{ background: "transparent" }}
                                                        >
                                                            <img src={LeftArrowsent} />

                                                        </button>



                                                    </span>
                                                </div>
                                                <h5
                                                >Click To View

                                                    <span>{
                                                        SubAssignedTicketBool == false ?
                                                            state.Ticketingrecord_dashboard.ticketDashboardData.sub_assigned :
                                                            state.Ticketingrecord_dashboard.ticketDashboardData.assigned
                                                    }</span>


                                                </h5>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                            :
                            <div className="col-12 DashboardOverviewticketing">
                                <div
                                    className="row TicketingDashboard"
                                    style={{ marginBottom: "44px" }}
                                >

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "over_due" ? "active-card" : ""
                                                }`}

                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"

                                            }}

                                            onClick={() => {
                                                handleButtonClick("over_due")
                                            }
                                            }

                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Over Due Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.Ticketingrecord_dashboard.ticketDashboardData.over_due_ticket_count ?
                                                            state.Ticketingrecord_dashboard.ticketDashboardData.over_due_ticket_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "Open" ? "active-card" : ""
                                                }`}
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"

                                            }}
                                            onClick={() => {
                                                handleButtonClick("Open")
                                            }
                                            }

                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Open Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.Ticketingrecord_dashboard.ticketDashboardData.open_ticketing_count ?
                                                            state.Ticketingrecord_dashboard.ticketDashboardData.open_ticketing_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "Inprocess" ? "active-card" : ""
                                                }`}

                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"

                                            }}

                                            onClick={() => {
                                                handleButtonClick("Inprocess")
                                            }
                                            }

                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            In Progress Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.Ticketingrecord_dashboard.ticketDashboardData.inprocess_ticketing_count ?
                                                            state.Ticketingrecord_dashboard.ticketDashboardData.inprocess_ticketing_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "Completed" ? "active-card" : ""
                                                }`}

                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"

                                            }}

                                            onClick={() => {
                                                handleButtonClick("Completed")
                                            }
                                            }


                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            // width: "126px"
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Review Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.Ticketingrecord_dashboard.ticketDashboardData.review_tickets_count ?
                                                            state.Ticketingrecord_dashboard.ticketDashboardData.review_tickets_count :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className="col-sm-2"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}

                                    >
                                        <div
                                            // className="card Dashboard01"
                                            className={`card Dashboard01 ${activeButton === "Close" ? "active-card" : ""
                                                }`}
                                            style={{
                                                borderRadius: "7px",
                                                border: "none",
                                                cursor: "pointer"
                                            }}

                                            onClick={() => {
                                                handleButtonClick("Close")
                                            }
                                            }

                                        >
                                            <div
                                                className="card-Body TicketDashboardCardBody"

                                            >
                                                <div className="InnerCardofTicket">
                                                    <div
                                                        className=" iconsEmpVer">

                                                        <img src={TicketIMAGES} style={{ height: "100%" }} />
                                                    </div>

                                                    <div
                                                        className="Counts"
                                                        style={{
                                                            fontSize: "30px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                        }}
                                                    >
                                                        <span
                                                        >
                                                            Resolved Tickets
                                                        </span>
                                                    </div>
                                                </div>


                                                <div className="CountsOftickets">
                                                    <span
                                                        className="DashboardCardHeader"
                                                    >
                                                        {state.Ticketingrecord_dashboard.ticketDashboardData.resolved_tickets ?
                                                            state.Ticketingrecord_dashboard.ticketDashboardData.resolved_tickets :
                                                            "0"
                                                        }

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>







                                </div>
                            </div>
                }

                <div className="row RecentTicket mt-4">

                    <div className="col RecentcardTickets mb-3">
                        {state.ClientBranchIDs.SUBROLE == 3 || UserTypeUds == "l3"
                            // state.SideBarFiles.NameRoles == "superAdmin"
                            // state.SideBarFiles.NameRoles == "" 

                            ?

                            <div className="card TicketClientDeatils shadow-sm  mb-3" style={{ borderRadius: "none" }}>
                                <div className="row align-items-center">

                                    <div className="col-12 Ticketingrecords">




                                        <div className="ticket-activity ">

                                            <div className='ToggleOFTicketActive'>

                                                <ul className="nav nav-tabs" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button

                                                            className={`  nav-link  ${state.FormsIDList.DashboardNavtabs == 1 ? "active" : ""
                                                                }`}
                                                            id="ex3-tab-1"
                                                            data-bs-toggle="tab"
                                                            href="#ex3-tabs-1"
                                                            role="tab"
                                                            aria-controls="ex3-tabs-1"
                                                            aria-selected={state.FormsIDList.DashboardNavtabs == 1}
                                                            onClick={() => {
                                                                dispatch(setDashboardactiveTabs(1));

                                                            }}
                                                        >
                                                            On Time Closure
                                                        </button>
                                                    </li>


                                                    <li className="nav-item" role="presentation">

                                                        <button
                                                            className={`   nav-link  ${state.FormsIDList.DashboardNavtabs == 2 ? "active" : ""
                                                                }`}
                                                            id="ex3-tab-3"
                                                            data-bs-toggle="tab"
                                                            href="#ex3-tabs-3"
                                                            role="tab"
                                                            aria-controls="ex3-tabs-3"
                                                            aria-selected={state.FormsIDList.DashboardNavtabs == 2}
                                                            onClick={() => {
                                                                dispatch(setDashboardactiveTabs(2));

                                                            }}
                                                        >Reopen Rate</button>
                                                    </li>

                                                </ul>
                                            </div>


                                            <>
                                                <div className="tab-content TicketContnent" id="ex2-content">
                                                    <div className={`  tab-pane fade show   ${state.FormsIDList.DashboardNavtabs == 1
                                                        ? "active "
                                                        : ""
                                                        }`}
                                                        id="ex3-tabs-1"
                                                        role="tabpanel"
                                                        aria-labelledby="ex3-tab-1">


                                                        <div className="HeaderofOntime">
                                                            <h5>Overall Percentage</h5>
                                                            <span>{

                                                                state.Ticketingrecord_dashboard.ticketDashboardData.overall_percentage != undefined &&
                                                                    state.Ticketingrecord_dashboard.ticketDashboardData.overall_percentage != null &&
                                                                    state.Ticketingrecord_dashboard.ticketDashboardData.overall_percentage != 0 ?
                                                                    Math.round(state.Ticketingrecord_dashboard.ticketDashboardData.overall_percentage) : 0}%</span>
                                                        </div>



                                                        <div style={{ width: "96%", height: "360px", padding: "7", marginTop: "4px", }}>

                                                            {state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData &&
                                                                (
                                                                    // Check if GraphData is not a single 0 or an array with only 0s
                                                                    Array.isArray(state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData)
                                                                        ? state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData.some(value => value !== 0)
                                                                        : state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData !== 0
                                                                ) ? (
                                                                <SimpleBarChart DateFilters={DateFilters} />
                                                            ) : (
                                                                <div>
                                                                    <div className="Dusbinback">
                                                                        <div>
                                                                            <img src={boximg} alt="No data available" />
                                                                            <p className="text-center">{"No data available"}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                            }


                                                        </div>
                                                    </div>


                                                    <div className={`  tab-pane fade show   ${state.FormsIDList.DashboardNavtabs == 2
                                                        ? "active "
                                                        : ""
                                                        }`}
                                                        id="ex3-tabs-3"
                                                        role="tabpanel"
                                                        aria-labelledby="ex3-tab-3">


                                                        <div className="HeaderofOntime">
                                                            <h5>Reopen Percentage</h5>
                                                            <span>{

                                                                state.Ticketingrecord_dashboard.ticketDashboardData.overall_percentage != undefined &&
                                                                    state.Ticketingrecord_dashboard.ticketDashboardData.overall_percentage != null &&
                                                                    state.Ticketingrecord_dashboard.ticketDashboardData.overall_percentage != 0 ?
                                                                    Math.round(state.Ticketingrecord_dashboard.ticketDashboardData.overall_percentage) : 0}%</span>
                                                        </div>


                                                        <div style={{ width: "96%", height: "360px", padding: "7", marginTop: "4px", }}>
                                                            {state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData &&
                                                                (
                                                                    // Check if GraphData is not a single 0 or an array with only 0s
                                                                    Array.isArray(state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData)
                                                                        ? state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData.some(value => value !== 0)
                                                                        : state.Ticketingrecord_dashboard?.ticketDashboardData?.GraphData !== 0
                                                                ) ? (
                                                                <SimpleBarChart DateFilters={DateFilters} />
                                                            ) : (
                                                                <div>
                                                                    <div className="Dusbinback">
                                                                        <div>
                                                                            <img src={boximg} alt="No data available" />
                                                                            <p className="text-center">{"No data available"}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                            }


                                                        </div>

                                                    </div>
                                                </div>
                                            </>

                                        </div>


                                    </div>


                                </div>
                            </div>
                            :
                            <>
                                <div className="card p-3">

                                    <div className='TickerSTatementHeaders'>
                                        <h5>Ticket Summary</h5>
                                        <button onClick={() => MoveTotheNextTab()}>View All</button>
                                    </div>

                                    <p className='Borderpara'></p>
                                    <div className="Groupbtn mb-3">
                                        <button
                                            className={`btn ${activeButton === "All" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("All")}
                                        >
                                            All
                                        </button>
                                        <button
                                            className={`btn ${activeButton === "Open" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Open")}
                                        >
                                            Open
                                        </button>
                                        <button
                                            className={`btn ${activeButton === "Inprocess" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Inprocess")}
                                        >
                                            In Progress
                                        </button>



                                        <button
                                            className={`btn ${activeButton === "Completed" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Completed")}
                                        >
                                            Review
                                        </button>
                                        <button
                                            className={`btn ${activeButton === "over_due" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("over_due")}
                                        >
                                            Over Due
                                        </button>

                                        <button
                                            className={`btn ${activeButton === "Reopen" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Reopen")}
                                        >
                                            Reopened
                                        </button>

                                        <button
                                            className={`btn ${activeButton === "Close" ? "active" : ""}`}
                                            onClick={() => handleButtonClick("Close")}
                                        >
                                            Resolved
                                        </button>

                                    </div>



                                    <div className='ContainsTickets'>

                                        {state.TrackingrecordgetOfSystemList.TrackingReport.length != 0 ?
                                            <>
                                                {state.TrackingrecordgetOfSystemList.TrackingReport != undefined && state.TrackingrecordgetOfSystemList.TrackingReport.map((item, index) => {
                                                    const ticketid = item.id;
                                                    // const lastFourDigits = ticketid ? ticketid.toString().slice(-6) : "---";
                                                    const lastFourDigits = item?.ticket_number;


                                                    return (
                                                        <>
                                                            <div className='containsticketprocess mt-3' key={index}
                                                                onClick={() => { HandleTheNeardueTickets(item) }}
                                                            >
                                                                <span className="priority-label inprocess"

                                                                    style={{
                                                                        background: item.status == 0 ? "hsla(170, 75%, 41%, 1)" : // Open - light background
                                                                            item.status == 1 ? "hsla(32, 92%, 59%, 1)" : // In Progress - yellow background
                                                                                item.status == 2 ? "hsla(170, 75%, 41%, 1)" : // Completed - light green background
                                                                                    item.status == 3 ? "hsla(140, 82%, 39%, 1)" : // Close - light green background for Close
                                                                                        "#234492", // Default for Reopen - light red background
                                                                        color: "#fff",
                                                                    }}

                                                                >

                                                                    {item.status == 0 ? "Open" :
                                                                        item.status == 1 ? "In Progress" :
                                                                            item.status == 2 ? "Review" :
                                                                                item.status == 3 ? "Resolved" : "Reopened"}</span>

                                                                {item.status == 3 ? null :

                                                                    <span className="OverDuedashboardparts">
                                                                        {/* {overdueFunctions(item)} */}
                                                                        {TicketoptionListed?.value == "external" ?
                                                                            overdueFunctions(item)
                                                                            :
                                                                            overdueFunctionsDepartment(item)

                                                                        }
                                                                    </span>
                                                                }


                                                                <div className="ticket-item mb-2">

                                                                    <div className="PriorityImgs" >
                                                                        <img
                                                                            src={item.priority == 0
                                                                                ? ticketresolvedticker
                                                                                : item.priority == 1
                                                                                    ? ticketreviewsticker
                                                                                    : ticketinprogressticker}
                                                                        // src={TicketBox}
                                                                        />
                                                                    </div>

                                                                    {TicketoptionListed?.value == "external" ?
                                                                        <div className="d-flex ContainsTicketsInner justify-content-between align-items-center">
                                                                            <div className='ticket-itemCols'>

                                                                                <h6>
                                                                                    <span className="LastNumberOftickets"> {lastFourDigits}</span>
                                                                                    {item?.client_id?.client_name
                                                                                        ? truncateText(
                                                                                            capitalizeEachWord(` - ${item?.client_id?.client_name.toLowerCase()}`),
                                                                                            40
                                                                                        )
                                                                                        : ""}

                                                                                </h6>
                                                                                <span className="text-muted DateFields">


                                                                                    {item?.clientsub_category_id?.name ? truncateText(capitalizeEachWord(`${item?.clientsub_category_id?.name.toLowerCase()}`), 40) : ""}
                                                                                    {/* {formatedDateList(item.created_at)} */}
                                                                                </span>



                                                                                {/* <p className="text-muted DateFields mb-0"> */}
                                                                                {/* Created   */}
                                                                                {/* <span>{formatedDateList(item.created_at)}</span></p> */}
                                                                            </div>

                                                                        </div>
                                                                        :
                                                                        <div className="d-flex ContainsTicketsInner justify-content-between align-items-center">
                                                                            <div className='ticket-itemCols'>

                                                                                <h6>
                                                                                    <span className="LastNumberOftickets"> {`I-${lastFourDigits}`}</span>
                                                                                    {item?.department_id?.department_name
                                                                                        ? truncateText(
                                                                                            capitalizeEachWord(` - ${item?.department_id?.department_name.toLowerCase()}`),
                                                                                            40
                                                                                        )
                                                                                        : ""}

                                                                                </h6>
                                                                                <span className="text-muted DateFields">


                                                                                    {item?.internal_category_id?.name ? truncateText(capitalizeEachWord(`${item?.internal_category_id?.name.toLowerCase()}`), 40) : ""}
                                                                                </span>
                                                                            </div>

                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}
                                            </>
                                            :
                                            // <p className="text-center">{"No data available"}</p>
                                            <div>

                                                <div className="Dusbinback">

                                                    <div>
                                                        <img src={boximg} />
                                                        <p className="text-center">{"No Tickets Available"}</p>

                                                    </div>
                                                </div>
                                            </div>
                                        }




                                    </div>
                                </div>

                            </>
                        }


                    </div>


                    <div className='col-5 FirstCards'>

                        <div className="col-5 Recentcard2">

                            <div className="card ClientDetailsCards">
                                <div className='TickerSTatementHeaders'>
                                    <h5>Nearing Due</h5>
                                    <div className="HaveNearduedateilsall">
                                        <button
                                            onClick={() => MoveTotheNextNeardue()}
                                        >View All</button>
                                    </div>
                                </div>
                                <div className="d-flex Recentcard2contact flex-column gap-3">
                                    <div className='ContainsTickets'>
                                        {TicketoptionListed?.value == "external" ?
                                            <>
                                                {state.NearDueCallingdatas.Nearduerecords.length != 0 ?
                                                    <>
                                                        {state.NearDueCallingdatas.Nearduerecords != undefined && state.NearDueCallingdatas.Nearduerecords.map((item, index) => {
                                                            const ticketid = item.id;
                                                            // const lastFourDigits = ticketid ? ticketid.toString().slice(-6) : "---";
                                                            const lastFourDigits = item?.ticket_number;

                                                            return (
                                                                <>
                                                                    <div className={`containsticketprocess mt-3 ${index == 0 ? "FirstCLient" : ""}`} key={index}>


                                                                        <div className="ticket-item  ticket-itemclient  mb-1" onClick={() => {
                                                                            HandleTheNeardueTickets(item)
                                                                        }}>
                                                                            <div className="InnertClientLists">
                                                                                <div className="PriorityImgs" >
                                                                                    <img
                                                                                        // src={TicketclientBox}
                                                                                        src={item.priority == 0
                                                                                            ? ticketresolvedticker
                                                                                            : item.priority == 1
                                                                                                ? ticketreviewsticker
                                                                                                : ticketinprogressticker}
                                                                                    />
                                                                                </div>
                                                                                <div className="d-flex ContainsTicketsInner justify-content-between align-items-center">
                                                                                    <div className='ticket-itemColsnear'>

                                                                                        <h6>
                                                                                            <span className="LastNumberOftickets"> {lastFourDigits}</span>
                                                                                            {item?.client_id?.client_name ? truncateText(capitalizeEachWord(` - ${item?.client_id?.client_name.toLowerCase()}`), 40) : ""}</h6>
                                                                                        <span className="text-muted DateFields">
                                                                                            {item?.clientsub_category_id?.name ? truncateText(capitalizeEachWord(`${item?.clientsub_category_id?.name.toLowerCase()}`), 40) : ""}
                                                                                            {/* {formatedDateList(item.created_at)} */}
                                                                                        </span>
                                                                                        {/* <p className="text-muted DateFields mb-0">Created Date <span>{formatDate(item.created_at)}</span></p> */}
                                                                                    </div>

                                                                                </div>

                                                                            </div>


                                                                            <div className={`${remainingTime == 0 || (formatDate(new Date()) != formatDate(item?.created_at)) ? "dayasclolosr" : " dayasclolosr"}`}>


                                                                                <p className="HeaderoftheDatefileds Dashboardneardues">


                                                                                    {overdueFunctions(item) != "Overdue" ?
                                                                                        <Stack spacing={2} direction="row">
                                                                                            <CircularProgress variant="determinate"
                                                                                                value={
                                                                                                    (() => {
                                                                                                        const response = overdueFunctions(item); // Get the response
                                                                                                        let percentage = 0; // Default to 0


                                                                                                        if (response && response.includes("Minutes left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Minutes left"); // Split the response
                                                                                                            // Extract the remaining time from the text (in minutes)
                                                                                                            const minutesLeft = Number(rest.join(""));
                                                                                                            const totalTAT = item?.client_id?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                            console.log(minutesLeft, typeof minutesLeft, isNaN(minutesLeft), "oasiudopasidopaisd minutesLeft", totalTAT, minutesLeft, Math.min((minutesLeft / totalTAT) * 100, 100));


                                                                                                            // Ensure the minutesLeft is a valid number
                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:");
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }


                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                console.error("Invalid totalTAT value:", totalTAT);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }
                                                                                                            if (totalTAT === 1) {
                                                                                                                // Directly use minutesLeft as a percentage of 100
                                                                                                                percentage = Math.min(minutesLeft, 100);
                                                                                                            } else {
                                                                                                                // Use the usual percentage formula
                                                                                                                percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                            }

                                                                                                            // percentage = Math.min((minutesLeft / totalTAT ) * 100, 100);
                                                                                                        }
                                                                                                        else if (response && response.includes("Hours left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Hours left");
                                                                                                            const minutesLeft = parseInt(minutesText.trim(), 10);

                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            const totalTAT = item?.client_id?.l1_user_TAT || 100;
                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                console.error("Invalid totalTAT value:", totalTAT);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                        }

                                                                                                        else if (response && response.includes("Days left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Days left");
                                                                                                            const minutesLeft = parseInt(minutesText.trim(), 10);
                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            const totalTAT = item?.client_id?.l1_user_TAT || 100;
                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                return percentage;
                                                                                                            }
                                                                                                            percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                        }

                                                                                                        console.log(percentage, "aspdopasidoasd percentage", response);

                                                                                                        return percentage;
                                                                                                    })()
                                                                                                }
                                                                                                style={{
                                                                                                    borderRadius: "50%",
                                                                                                    width: "59px",
                                                                                                    height: "59px",
                                                                                                    background: "transparent", // Conditional background color based on the value
                                                                                                    // border: "2px solid", // Ensure a border is present
                                                                                                    borderColor: "#234492",
                                                                                                    color: "#234492",
                                                                                                    marginRight: "-16px !important"
                                                                                                    // color: 10 === 90 ? "#234492" : "gray", // Conditional border color based on the value
                                                                                                    // borderColor: overdueFunctionspercentanges(item) >10 ? "#234492" : "gray", // Conditional border color based on the value
                                                                                                }}

                                                                                                sx={{
                                                                                                    borderRadius: "50%",
                                                                                                    width: "55px",
                                                                                                    height: "55px",
                                                                                                    backgroundColor: "transparent", // Conditional background color
                                                                                                    // border: "2px solid", // Border width
                                                                                                    borderColor: 90 === 90 ? "#234492" : "gray", // Conditional border color
                                                                                                }}
                                                                                            />

                                                                                            <span className="HeaderoftheDatefiledsNameDashboard">
                                                                                                {(() => {
                                                                                                    const response = overdueFunctions(item); // Get the response

                                                                                                    if (response) {
                                                                                                        // Check for specific time-related keywords
                                                                                                        if (response.includes("Minutes left")) {
                                                                                                            // const minutes = response.split("Minutes left")[0].trim();
                                                                                                            const [minutesText, ...rest] = response.split("Minutes left"); // Split the response

                                                                                                            return <> <span>{rest.join("")}</span><span className="MinutesLeft">

                                                                                                                {"Minutes"}</span></>


                                                                                                        } else if (response.includes("Hours left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Hours left"); // Split the response
                                                                                                            const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value

                                                                                                            // const hours = response.split("Hours left")[0].trim();

                                                                                                            // return <span className="HoursLeft">{daysLeft}<br />{"Hours"}</span>;

                                                                                                            return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                                                                                {"Hours"}</span></>
                                                                                                        } else if (response.includes("Days left")) {
                                                                                                            // const days = response.split("Days left")[0].trim();
                                                                                                            const [minutesText, ...rest] = response.split("Days left"); // Split the response
                                                                                                            const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value
                                                                                                            // return <span className="DaysLeft">{`Days  ${daysLeft}`}</span>;
                                                                                                            // return <span className="HoursLeft">{daysLeft}<br />{"Days"}</span>;

                                                                                                            return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                                                                                {"Days"}</span></>

                                                                                                        } else if (response === "Overdue") {
                                                                                                            return <span className="OverdueText">Overdue</span>;
                                                                                                        }
                                                                                                    }

                                                                                                    return null; // Render nothing if response is not defined
                                                                                                })()}

                                                                                            </span>
                                                                                        </Stack>
                                                                                        :
                                                                                        <span className="OverdueText">Overdue</span>}


                                                                                </p>


                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </>


                                                    :
                                                    <>
                                                        <div>

                                                            <div className="Dusbinback Dusbinbackneardues">

                                                                <div>
                                                                    <img src={boximg} />
                                                                    <p className="text-center">{"No Tickets Nearing Due"}</p>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>}
                                            </>
                                            :
                                            <>
                                                {state.NearDueCallingdatas.Nearduerecords.length != 0 ?
                                                    <>
                                                        {state.NearDueCallingdatas.Nearduerecords != undefined && state.NearDueCallingdatas.Nearduerecords.map((item, index) => {
                                                            const ticketid = item.id;
                                                            const lastFourDigits = item?.ticket_number;


                                                            return (
                                                                <>
                                                                    <div className={`containsticketprocess mt-3 ${index == 0 ? "FirstCLient" : ""}`} key={index}>


                                                                        <div className="ticket-item  ticket-itemclient  mb-1" onClick={() => {
                                                                            HandleTheNeardueTickets(item)
                                                                        }}>
                                                                            <div className="InnertClientLists">
                                                                                <div className="PriorityImgs" >
                                                                                    <img
                                                                                        src={item.priority == 0
                                                                                            ? ticketresolvedticker
                                                                                            : item.priority == 1
                                                                                                ? ticketreviewsticker
                                                                                                : ticketinprogressticker}
                                                                                    />
                                                                                </div>
                                                                                <div className="d-flex ContainsTicketsInner justify-content-between align-items-center">
                                                                                    <div className='ticket-itemColsnear'>

                                                                                        <h6>
                                                                                            <span className="LastNumberOftickets"> {`I-${lastFourDigits}`}</span>
                                                                                            {item?.department_id?.department_name ? truncateText(capitalizeEachWord(` - ${item?.department_id?.department_name.toLowerCase()}`), 40) : ""}</h6>
                                                                                        <span className="text-muted DateFields">
                                                                                            {item?.internal_category_id?.name ? truncateText(capitalizeEachWord(`${item?.internal_category_id?.name.toLowerCase()}`), 40) : ""}
                                                                                        </span>
                                                                                    </div>

                                                                                </div>

                                                                            </div>


                                                                            <div className={`${remainingTime == 0 || (formatDate(new Date()) != formatDate(item?.created_at)) ? "dayasclolosr" : " dayasclolosr"}`}>

                                                                                <p className="HeaderoftheDatefileds Dashboardneardues">


                                                                                    {overdueFunctionsDepartment(item) != "Overdue" ?
                                                                                        <Stack spacing={2} direction="row">
                                                                                            <CircularProgress variant="determinate"


                                                                                                value={
                                                                                                    (() => {
                                                                                                        const response = overdueFunctionsDepartment(item); // Get the response
                                                                                                        let percentage = 0; // Default to 0


                                                                                                        if (response && response.includes("Minutes left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Minutes left"); // Split the response
                                                                                                            // Extract the remaining time from the text (in minutes)
                                                                                                            const minutesLeft = Number(rest.join(""));
                                                                                                            const totalTAT = item?.department_users?.l1_user_TAT || 100; // Default to 100 if no TAT is available

                                                                                                            // console.log(minutesLeft, typeof minutesLeft, isNaN(minutesLeft), "oasiudopasidopaisd minutesLeft", totalTAT, minutesLeft, Math.min((minutesLeft / totalTAT) * 100, 100));


                                                                                                            // Ensure the minutesLeft is a valid number
                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:");
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }


                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                console.error("Invalid totalTAT value:", totalTAT);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }
                                                                                                            if (totalTAT === 1) {
                                                                                                                // Directly use minutesLeft as a percentage of 100
                                                                                                                percentage = Math.min(minutesLeft, 100);
                                                                                                            } else {
                                                                                                                // Use the usual percentage formula
                                                                                                                percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                            }

                                                                                                            // percentage = Math.min((minutesLeft / totalTAT ) * 100, 100);
                                                                                                        }
                                                                                                        else if (response && response.includes("Hours left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Hours left");
                                                                                                            const minutesLeft = parseInt(minutesText.trim(), 10);

                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            const totalTAT = item?.department_users?.l1_user_TAT || 100;
                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                console.error("Invalid totalTAT value:", totalTAT);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                        }

                                                                                                        else if (response && response.includes("Days left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Days left");
                                                                                                            const minutesLeft = parseInt(minutesText.trim(), 10);
                                                                                                            if (isNaN(minutesLeft)) {
                                                                                                                console.error("Invalid minutesLeft value:", minutesLeft);
                                                                                                                return percentage; // Return 0 if invalid
                                                                                                            }

                                                                                                            const totalTAT = item?.department_users?.l1_user_TAT || 100;
                                                                                                            if (isNaN(totalTAT)) {
                                                                                                                return percentage;
                                                                                                            }
                                                                                                            percentage = Math.min((minutesLeft / totalTAT) * 100, 100);
                                                                                                        }

                                                                                                        console.log(percentage, "aspdopasidoasd percentage", response);

                                                                                                        return percentage;
                                                                                                    })()
                                                                                                }
                                                                                                style={{
                                                                                                    borderRadius: "50%",
                                                                                                    width: "59px",
                                                                                                    height: "59px",
                                                                                                    background: "transparent", // Conditional background color based on the value
                                                                                                    borderColor: "#234492",
                                                                                                    color: "#234492",
                                                                                                    marginRight: "-16px !important"
                                                                                                }}

                                                                                                sx={{
                                                                                                    borderRadius: "50%",
                                                                                                    width: "55px",
                                                                                                    height: "55px",
                                                                                                    backgroundColor: "transparent", // Conditional background color
                                                                                                    // border: "2px solid", // Border width
                                                                                                    borderColor: 90 === 90 ? "#234492" : "gray", // Conditional border color
                                                                                                }}
                                                                                            />

                                                                                            <span className="HeaderoftheDatefiledsNameDashboard">
                                                                                                {(() => {
                                                                                                    const response = overdueFunctionsDepartment(item); // Get the response

                                                                                                    if (response) {
                                                                                                        // Check for specific time-related keywords
                                                                                                        if (response.includes("Minutes left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Minutes left"); // Split the response

                                                                                                            return <> <span>{rest.join("")}</span><span className="MinutesLeft">

                                                                                                                {"Minutes"}</span></>


                                                                                                        } else if (response.includes("Hours left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Hours left"); // Split the response
                                                                                                            const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value
                                                                                                            return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                                                                                {"Hours"}</span></>
                                                                                                        } else if (response.includes("Days left")) {
                                                                                                            const [minutesText, ...rest] = response.split("Days left"); // Split the response
                                                                                                            const daysLeft = parseInt(minutesText.trim(), 10); // Extract the days value
                                                                                                            return <> <span>{daysLeft}</span><span className="MinutesLeft">

                                                                                                                {"Days"}</span></>

                                                                                                        } else if (response === "Overdue") {
                                                                                                            return <span className="OverdueText">Overdue</span>;
                                                                                                        }
                                                                                                    }

                                                                                                    return null; // Render nothing if response is not defined
                                                                                                })()}

                                                                                            </span>
                                                                                        </Stack>
                                                                                        :
                                                                                        <span className="OverdueText">Overdue</span>}


                                                                                </p>


                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </>
                                                    :
                                                    <>
                                                        <div>

                                                            <div className="Dusbinback Dusbinbackneardues">

                                                                <div>
                                                                    <img src={boximg} />
                                                                    <p className="text-center">{"No Tickets Nearing Due"}</p>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>}
                                            </>
                                        }



                                    </div>




                                </div>
                            </div>
                        </div>
                    </div>

                </div>
{state.ClientBranchIDs.SUBROLE == 3 &&(

        <div class="row align-items-center" style={{margin:"27px 7px"}}>
            <div className="col-12">
                        <Customerdatas  
                    
                        range={range}
                        datas={datas}
                                    client={Client}
            priority={PriorityValues}
            status={SttausValues}
  
            date={DateFilters}



                    />
            </div>

              <div className="col-12">
                        <Statebasedtickets  
                    
                        range={range}
                        datas={datas}
                                    client={Client}
                             priority={PriorityValues}
                       status={SttausValues}
  
                               date={DateFilters}
                                              />
               </div>

               <div className="col-12">
                <CustomedashboardPie 
                
                                        datas={datas}
                                    client={Client}
                             priority={PriorityValues}
                       status={SttausValues}
  
                               date={DateFilters}/>
                               
                </div>
                    </div>
                    )}
            </div >
            {
                TicketListpoup && (
                    <div className="RoleCreatePopup">
                        <div className="BeforePopUp">
                            <div className="RolePopups" style={{ width: "70%" }}>
                                <div className="asds">
                                    <div class="ModalHeaderTicketlistviews" style={{ background: "#234492", display: "flex", justifyContent: "space-between", border: "none", color: "#fff", alignItems: "center" }}>
                                        <span className="TicketSummaryname" >Ticket Summary</span>

                                        <div className="CloseIcon" onClick={(e) => {
                                            setticketlistPopup(false);
                                        }}>
                                            <CloseOutlinedIcon className="CloseIconsListed" />
                                        </div>
                                    </div>
                                    <div className="row RecentTicket RecentTicketPopups mb-3" style={{ padding: "0 !important" }}>
                                        <div className="col RecentcardTickets mb-3">

                                            <div className="card p-3">

                                                {/* <div className='TickerSTatementHeaders'>
                                        <h5>Ticket Summary</h5>
                                        <button onClick={() => MoveTotheNextTab()}>View All</button>
                                    </div> */}

                                                <p className='Borderpara'></p>
                                                <div className="GroupofButtons">
                                                    <div className="Groupbtn mb-3">
                                                        <button
                                                            className={`btn ${activeButton === "All" ? "active" : ""}`}
                                                            onClick={() => handleButtonClick("All")}
                                                        >
                                                            All
                                                        </button>
                                                        <button
                                                            className={`btn ${activeButton === "Open" ? "active" : ""}`}
                                                            onClick={() => handleButtonClick("Open")}
                                                        >
                                                            Open
                                                        </button>
                                                        <button
                                                            className={`btn ${activeButton === "Inprocess" ? "active" : ""}`}
                                                            onClick={() => handleButtonClick("Inprocess")}
                                                        >
                                                            In Progress
                                                        </button>



                                                        <button
                                                            className={`btn ${activeButton === "Completed" ? "active" : ""}`}
                                                            onClick={() => handleButtonClick("Completed")}
                                                        >
                                                            Review
                                                        </button>
                                                        <button
                                                            className={`btn ${activeButton === "over_due" ? "active" : ""}`}
                                                            onClick={() => handleButtonClick("over_due")}
                                                        >
                                                            Over Due
                                                        </button>
                                                        <button
                                                            className={`btn ${activeButton === "Rejected" ? "active" : ""}`}
                                                            onClick={() => handleButtonClick("Rejected")}
                                                        >
                                                            Rejected
                                                        </button>

                                                        <button
                                                            className={`btn ${activeButton === "Reopen" ? "active" : ""}`}
                                                            onClick={() => handleButtonClick("Reopen")}
                                                        >
                                                            Reopened
                                                        </button>

                                                        <button
                                                            className={`btn ${activeButton === "Close" ? "active" : ""}`}
                                                            onClick={() => handleButtonClick("Close")}
                                                        >
                                                            Resolved
                                                        </button>



                                                    </div>
                                                    <button className="ViewAllButtons" onClick={() => MoveTotheNextTab()}>View All</button>

                                                </div>


                                                <div className='ContainsTickets'>

                                                    {state.TrackingrecordgetOfSystemList.TrackingReport.length != 0 ?
                                                        <>
                                                            {state.TrackingrecordgetOfSystemList.TrackingReport != undefined && state.TrackingrecordgetOfSystemList.TrackingReport.map((item, index) => {
                                                                const ticketid = item.id;
                                                                const lastFourDigits = item?.ticket_number;
                                                                // console.log(item, ticketid, "asoidoiasidiasd ticketid");


                                                                return (
                                                                    <>
                                                                        <div className='containsticketprocess mt-3' key={index}
                                                                            onClick={() => {
                                                                                console.log(item, "saodpaosidpoas ditem");

                                                                                // HandleTheNeardueTickets(item)
                                                                                setTimeout(() => {
                                                                                    dispatch(settheTicketIDSActions(item.id)); /// ticket id
                                                                                }, 50);
                                                                                // console.log(datas ,"sdosaopdias ddatas");        
                                                                                // dispatch(getSideBarfilesActions("Tickets"));
                                                                                // setTimeout(() => {
                                                                                // Navigate("/ticketviews")
                                                                                // }, 300)

                                                                            }}
                                                                        >
                                                                            <span className="priority-label inprocess"

                                                                                style={{
                                                                                    background: item.status == 0 ? "hsla(170, 75%, 41%, 1)" : // Open - light background
                                                                                        item.status == 1 ? "hsla(32, 92%, 59%, 1)" : // In Progress - yellow background
                                                                                            item.status == 2 ? "hsla(170, 75%, 41%, 1)" : // Completed - light green background
                                                                                                item.status == 3 ? "hsla(140, 82%, 39%, 1)" : // Close - light green background for Close
                                                                                                    "#234492", // Default for Reopen - light red background
                                                                                    color: "#fff",
                                                                                }}

                                                                            >

                                                                                {item.status == 0 ? "Open" :
                                                                                    item.status == 1 ? "In Progress" :
                                                                                        item.status == 2 ? "Review" :
                                                                                            item.status == 3 ? "Resolved" : "Reopened"}</span>

                                                                            {item.status == 3 ? null :

                                                                                <span className="OverDuedashboardparts">
                                                                                    {TicketoptionListed?.value == "external" ?
                                                                                        overdueFunctions(item)
                                                                                        :
                                                                                        overdueFunctionsDepartment(item)

                                                                                    }

                                                                                </span>
                                                                            }


                                                                            <div className="ticket-item mb-2">

                                                                                <div className="PriorityImgs" >
                                                                                    <img
                                                                                        src={item.priority == 0
                                                                                            ? ticketresolvedticker
                                                                                            : item.priority == 1
                                                                                                ? ticketreviewsticker
                                                                                                : ticketinprogressticker}
                                                                                    />
                                                                                </div>
                                                                                {/* <div className="d-flex ContainsTicketsInner justify-content-between align-items-center">

                                                                                    <div className='ticket-itemCols'>

                                                                                        <h6>
                                                                                            <span className="LastNumberOftickets"> {lastFourDigits}</span>
                                                                                            {item?.client_id?.client_name
                                                                                                ? truncateText(
                                                                                                    capitalizeEachWord(` - ${item?.client_id?.client_name.toLowerCase()}`),
                                                                                                    40
                                                                                                )
                                                                                                : ""}

                                                                                        </h6>
                                                                                        <span className="text-muted DateFields">


                                                                                            {item?.clientsub_category_id?.name ? truncateText(capitalizeEachWord(`${item?.clientsub_category_id?.name.toLowerCase()}`), 40) : ""}
                                                                                        </span>
                                                                                    </div>



                                                                                </div> */}
                                                                                {TicketoptionListed?.value == "external" ?
                                                                                    <div className="d-flex ContainsTicketsInner justify-content-between align-items-center">
                                                                                        <div className='ticket-itemCols'>

                                                                                            <h6>
                                                                                                <span className="LastNumberOftickets"> {lastFourDigits}</span>
                                                                                                {item?.client_id?.client_name
                                                                                                    ? truncateText(
                                                                                                        capitalizeEachWord(` - ${item?.client_id?.client_name.toLowerCase()}`),
                                                                                                        40
                                                                                                    )
                                                                                                    : ""}

                                                                                            </h6>
                                                                                            <span className="text-muted DateFields">


                                                                                                {item?.clientsub_category_id?.name ? truncateText(capitalizeEachWord(`${item?.clientsub_category_id?.name.toLowerCase()}`), 40) : ""}
                                                                                            </span>



                                                                                        </div>

                                                                                    </div>
                                                                                    :
                                                                                    <div className="d-flex ContainsTicketsInner justify-content-between align-items-center">
                                                                                        <div className='ticket-itemCols'>

                                                                                            <h6>
                                                                                                <span className="LastNumberOftickets"> {`I-${lastFourDigits}`}</span>
                                                                                                {item?.department_id?.department_name
                                                                                                    ? truncateText(
                                                                                                        capitalizeEachWord(` - ${item?.department_id?.department_name.toLowerCase()}`),
                                                                                                        40
                                                                                                    )
                                                                                                    : ""}

                                                                                            </h6>
                                                                                            <span className="text-muted DateFields">
                                                                                                {item?.internal_category_id?.name ? truncateText(capitalizeEachWord(`${item?.internal_category_id?.name.toLowerCase()}`), 40) : ""}
                                                                                            </span>
                                                                                        </div>

                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })}
                                                        </>
                                                        :
                                                        <div>

                                                            <div className="Dusbinback">

                                                                <div>
                                                                    <img src={boximg} />
                                                                    <p className="text-center">{"No Tickets Available"}</p>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    }




                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                )
            }



        </>

    )
}

export default TicketDashboard